import ConfirmDialog from '@/commons/confirm-dialog/ConfirmDialog';
import { Iconic } from '@/commons/iconic';
import { ActionsProps } from '@/components/Table/types/actions';
import { PATH_DASHBOARD } from '@/routes/paths';
import { MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Button } from '@PorkyCol/button';


export const ListActionsCashRegister = ({
  value,
  openConfirm,
  setOpenConfirm,
  setOpenPopover,
}: ActionsProps) => {
  const navigate_cash_register: any = {
    view: PATH_DASHBOARD['cash-register'].view,
    edit: PATH_DASHBOARD['cash-register'].edit,
  };
  const navigate = useNavigate();

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleEdit = () => {
    navigate(navigate_cash_register.edit(value));
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      <MenuItem onClick={handleEdit}>
        <Iconic icon="eva:edit-fill" />
        Editar
      </MenuItem>
      <MenuItem
        onClick={() => {
          handleOpenConfirm();
        }}
        sx={{ color: 'error.main' }}
      >
        <Iconic icon="eva:trash-2-outline" />
        estado
      </MenuItem>

      <ConfirmDialog
        open={openConfirm}
        onClose={handleCloseConfirm}
        title="Change"
        content="Are you sure want to change?"
        action={
          <Button
            variant="solid"
            color="danger"
            onClick={() => {
              handleClosePopover();
            }}
          >
            Cambiar
          </Button>
        }
      />
    </>
  );
};
